import kebabCase from 'lodash/kebabCase'
import queryString from 'query-string'

import { buildQueryParamsFromFilters, IFilters, ISearchRegion } from 'main/util/search'

export function schoolSearchPath(filters?: IFilters) {
  return `/search${filtersQuery(filters)}`
}

export function schoolSearchLocationPath(location: string, filters?: IFilters) {
  return `/search/${slugify(location)}${filtersQuery(filters)}`
}

export function regionSearchPath(region: ISearchRegion, filters?: IFilters) {
  const { state, city } = region
  return `/${kebabCase(state)}/${kebabCase(city)}${filtersQuery(filters)}`
}

function filtersQuery(filters?: IFilters) {
  if (!filters) return ''

  const params = buildQueryParamsFromFilters(filters)
  return `?${queryString.stringify(params, { arrayFormat: 'comma' })}`
}

function slugify(query: string) {
  return query.replace(/,[\s?]+/, '-').replace(/\s+/, '+')
}
